import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import type { IPreviewCommon } from '@shared/common/data/products';

@Component({
  selector: 'app-carousel[products]',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselComponent {
  @Input() products!: IPreviewCommon[] | Readonly<IPreviewCommon[]>;

  @Output() buttonClick = new EventEmitter<
    IPreviewCommon | Readonly<IPreviewCommon>
  >();

  // constructor() {}

  public onButtonClick(product: IPreviewCommon | Readonly<IPreviewCommon>) {
    this.buttonClick.emit(product);
  }
}
